import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface FrameLayoutProps {
    title?: string;
    className?: string;
    testid?: string;
}

const FrameLayout: FC<PropsWithChildren<FrameLayoutProps>> = ({ title, className, testid, children }) => {
    return (
        <section
            data-testid={testid}
            className={twMerge('flex flex-col space-y-4 py-4 px-4 lg:px-8 w-full h-full', className)}
        >
            {title && <h1 className="font-poppins font-semibold text-xl">{title}</h1>}
            {children}
        </section>
    );
};

export default FrameLayout;
